import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span>&copy;  Bản quyền thuộc về <a href="https://linkphar.com/" target="_blank">LinkPhar.JSC</a></span>
        <span className="ml-auto">
          Cung cấp bởi: 
          <a href="https://linkphar.com/" target="_blank">LinkPhar.JSC</a>
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js